import cookieService from '@/modules/cookieService'

function clientGetTheme() {
  const locale = cookieService.getCookie('theme') || 'dark'

  return locale
}

export default clientGetTheme
